import request from "../utils/request";
import {
    GET_CAPTCHA_FROM_FORGET,
    VERIFY_ACCOUNT_FROM_FORGET,
    SEND_VERIFICATION_CODE_FROM_FORGET,
    VERIFY_VERIFICATION_CODE_FROM_FORGET,
    VERIFY_QUESTION_FROM_FORGET
} from "@/constants/apis";

export const getCaptcha = data => {
    return request({
        method: "get",
        url: GET_CAPTCHA_FROM_FORGET,
        data
    });
};

export const verifyAccount = data => {
    return request({
        url: VERIFY_ACCOUNT_FROM_FORGET,
        data
    });
};

export const sendCode = data => {
    let url = SEND_VERIFICATION_CODE_FROM_FORGET.replace("<type>", data.type);
    return request({
        url,
        data
    });
};

export const verifyCode = data => {
    let url = VERIFY_VERIFICATION_CODE_FROM_FORGET.replace("<type>", data.type);
    return request({
        url,
        data
    });
};

export const verifyQa = data => {
    return request({
        url: VERIFY_QUESTION_FROM_FORGET,
        data
    });
};
